import { FC, useState } from "react";
import { useTranslation } from "react-i18next";
import "./i18n";
import {
  handleLanguageChange, isArabicCurrentLanguage,
  secureLocalStorageGet,
  secureLocalStorageSet,
} from "../../../utils";
import { SystemConfiguration } from "../../../configuration";
import arabicFlag from "../../../assets/images/flags/arabicFlag.png";
import englishFlag from "../../../assets/images/flags/englishFlag.png";

const languageLocalStorageName =
  SystemConfiguration.culture_Configurations.currentCulture;
const defaultUiLanguage =
  SystemConfiguration.culture_Configurations.defaultUiLanguage;
const getDefaultLanguage = (): string => {
  // @ts-ignore
  const localeValueFomStorage = secureLocalStorageGet(languageLocalStorageName);
  if (
    localeValueFomStorage === null ||
    localeValueFomStorage === undefined ||
    localeValueFomStorage === ""
  ) {
    secureLocalStorageSet(languageLocalStorageName, defaultUiLanguage);
    return defaultUiLanguage;
  }
  return localeValueFomStorage as string;
};
const LangSwitcherReactI18: FC = () => {
  //#region state
  const { i18n } = useTranslation();
  const [language, setLanguage] = useState(getDefaultLanguage);
  //#endregion
  //#region function
  const handleLanguageSelect = (e: any) => {
    i18n.changeLanguage(e.target.value).then(() => {});
    setLanguage(e.target.value);
    secureLocalStorageSet(languageLocalStorageName || "", e.target.value);
  };
  //#endregion
  //#region html
  return (
    <>
      <div className="language-switch">
        {language !== "ar-AE" && (
          <img
            src={arabicFlag}
            alt="Arabic"
            className="btn-ar"
            onClick={() => handleLanguageChange()}
          />
        )}
        {language === "ar-AE" && (
          <img
            src={englishFlag}
            alt="English"
            className="btn-en"
            onClick={() => handleLanguageChange()}
          />
        )}
      </div>
    </>
  );
  //#endregion
};
export { LangSwitcherReactI18, getDefaultLanguage };
